import { render, staticRenderFns } from "./AuthChangePhoneNumber.vue?vue&type=template&id=201642c6&scoped=true&"
import script from "./AuthChangePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./AuthChangePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./AuthChangePhoneNumber.vue?vue&type=style&index=0&id=201642c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201642c6",
  null
  
)

export default component.exports